import { CONSULTATION_STEPS, CONSULTATION_TYPE } from '@abiglobalhealth/go-types'
import { PhoneNumberPopupWrapper } from '@components/Consultation/components/PhoneNumberPopupWrapper'
import { Answer } from '@components/Consultation/steps/Answer'
import { Form } from '@components/Consultation/steps/Form'
import { IndicationSurvey } from '@components/Consultation/steps/IndicationSurvey'
import { Landing } from '@components/Consultation/steps/Landing'
import { Match } from '@components/Consultation/steps/Match'
import { Matching } from '@components/Consultation/steps/Matching'
import { VideoCall } from '@components/Consultation/steps/VideoCall'
import { VideoCallEnded } from '@components/Consultation/steps/VideoCallEnded'
import React, { useMemo } from 'react'

import { WaitingForConsultationPayment } from '@/components/Consultation/steps/WaitingForConsultationPayment'
import { WaitingForInfo } from '@/components/Consultation/steps/WaitingForInfo'
import { WaitingForSwap } from '@/components/Consultation/steps/WaitingForSwap'
import { useConsultationStep } from '@/hooks/useConsultationStep'
import { useConsultationType } from '@/hooks/useConsultationType'

const CONSULTATION_STEPS_COMPONENTS: Record<CONSULTATION_STEPS, React.FC> = {
  [CONSULTATION_STEPS.LANDING]: Landing,
  [CONSULTATION_STEPS.FORM]: Form,
  [CONSULTATION_STEPS.MATCHING]: Matching,
  [CONSULTATION_STEPS.MATCH]: Match,
  [CONSULTATION_STEPS.ANSWER]: Answer,
  [CONSULTATION_STEPS.INDICATION_SURVEY]: IndicationSurvey,
  [CONSULTATION_STEPS.ONGOING_VIDEO_CALL]: VideoCall,
  [CONSULTATION_STEPS.VIDEO_CALL_ENDED]: VideoCallEnded,
  [CONSULTATION_STEPS.WAITING_FOR_INFO]: WaitingForInfo,
  [CONSULTATION_STEPS.WAITING_FOR_SWAP]: WaitingForSwap,
  [CONSULTATION_STEPS.WAITING_FOR_CONSULTATION_PAYMENT]: WaitingForConsultationPayment,
  [CONSULTATION_STEPS.MENTAL_HEALTH_DISCLAIMER]: () => <></>
}

export const Consultation = () => {
  const { consultationType } = useConsultationType()
  const { currentConsultationStep } = useConsultationStep()

  const showPhoneNumberPopup = useMemo(() => {
    switch (currentConsultationStep) {
      case CONSULTATION_STEPS.MATCHING:
      case CONSULTATION_STEPS.MATCH:
        return consultationType !== CONSULTATION_TYPE.VIDEO

      case CONSULTATION_STEPS.VIDEO_CALL_ENDED:
        return true

      default:
        return false
    }
  }, [currentConsultationStep, consultationType])

  if (!currentConsultationStep) return null

  const Component = CONSULTATION_STEPS_COMPONENTS[currentConsultationStep]

  return (
    <>
      <Component />
      {showPhoneNumberPopup && <PhoneNumberPopupWrapper />}
    </>
  )
}
